import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAlert } from "../../../../context/AlertContext";
import { useLoading } from "../../../../context/LoadingContext";
import { hasValueObjects } from "../../../../utils/ManageArray";
import { addEditServiceRequest } from "../../../../commons/ServiceRequest";
import CreateJobForm from "../../../../components/GeneralJobForm/CreateJobForm";
import ItemOthersService from "../../../../services/itemother.service";
import FileUploadsService from "../../../../services/fileupload.service";
import JobOtherPricesService from "../../../../services/jobotherprice.service";
import InformOtherJobsService from "../../../../services/informotherjob.service";
import InformOtherJobFilesService from "../../../../services/informotherjobfile.service";

export default function EditJob() {
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const [editData, setEditData] = useState({ type: "edit" });
  const emptyItem = ["Job_Other_Id", "Item_Serial", "Com_Code"];
  const emptyJob = ["Job_Other_Id", "Com_Code"];

  const commonHas = (data, pass) =>
    hasValueObjects(data, pass)?.hasValue?.length > 0;
  const commonNavigate = (Inform_Id) => {
    navigate("/general_job/create", {
      state: { name: "edit", searchValue: `${Inform_Id}` }
    });
    navigate(0);
  };

  const handleSubmit = ({ Inform, Item, Job }, uploadFile) => {
    const files = [
      ...uploadFile.Image.filter((item) => item instanceof File),
      ...uploadFile.Video.filter((item) => item instanceof File)
    ];
    const refreshAt =
      files?.length > 0
        ? "InformFiles"
        : commonHas(Job.Array, emptyJob)
        ? "JobOther"
        : commonHas(Item.Array, emptyItem)
        ? "ItemOther"
        : "Inform";
    const Inform_Id = Inform?.Array?.[0]?.Id;
    handleSubmitInformOtherJobs({ Inform, Inform_Id, refreshAt });
    if (commonHas(Item.Array, emptyItem))
      handleSubmitItemOthers({ Item, Inform_Id, refreshAt });
    if (commonHas(Job.Array, emptyJob))
      handleSubmitJobOtherPrices({ Job, Inform_Id, refreshAt });
    if (files?.length > 0)
      handleUploadFile({
        destination: "ใบแจ้งงาน/Media",
        files,
        Inform_Id,
        refreshAt
      });
  };

  const handleSubmitInformOtherJobs = ({ Inform, Inform_Id, refreshAt }) => {
    const modifiedItem = Inform.Array.map(
      ({
        Id,
        Job_Type_Id,
        Job_Type_Sub_Id,
        Cus_Id,
        Employee_Id,
        Inform_By_Id,
        InformOtherJobFiles,
        JobType,
        JobTypeSub,
        Customer,
        BPCustomer,
        Employee,
        CustContract,
        InformEmployee,
        ItemOther,
        JobOtherPrice,
        createdAt,
        createdBy,
        updatedAt,
        updatedBy,
        ...item
      }) => ({
        ...item,
        Job_Type_Id: Number(Job_Type_Id) || null,
        Job_Type_Sub_Id: Number(Job_Type_Sub_Id) || null,
        Cus_Id: Number(Cus_Id) || null,
        Employee_Id: Number(Employee_Id) || null,
        Inform_By_Id: Number(Inform_By_Id) || null
      })
    )?.[0];

    addEditServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: InformOtherJobsService.editInformOtherJobs(
        Inform_Id,
        modifiedItem
      ),
      navigated: (navi) =>
        navi && refreshAt === "Inform" && commonNavigate(Inform_Id)
    });
  };

  const handleSubmitItemOthers = ({ Item, Inform_Id, refreshAt }) => {
    Item.Array.forEach(
      ({
        Id,
        Item_Id,
        Item_Install_Qty,
        Item_Price_Per_Unit,
        Item_Amount,
        ...item
      }) => {
        const modifiedItem = {
          ...item,
          Job_Other_Id: Inform_Id,
          Item_Id: Number(Item_Id) || null,
          Item_Install_Qty: Number(Item_Install_Qty) || null,
          Item_Price_Per_Unit: Number(Item_Price_Per_Unit) || null,
          Item_Amount: Number(Item_Amount) || null
        };

        const serviceRequest = Id
          ? ItemOthersService.editItemOthers(Id, modifiedItem)
          : ItemOthersService.createItemOthers({ Array: [modifiedItem] });

        addEditServiceRequest({
          showAlert,
          setLoading,
          serviceRequest,
          navigated: (navi) =>
            navi && refreshAt === "ItemOther" && commonNavigate(Inform_Id)
        });
      }
    );
  };

  const handleSubmitJobOtherPrices = ({ Job, Inform_Id, refreshAt }) => {
    Job.Array.forEach(({ Id, Oth_Price, ...item }) => {
      const modifiedItem = {
        ...item,
        Job_Other_Id: Inform_Id,
        Oth_Price: Number(Oth_Price) || null,
        Oth_Price_Unit: item.Oth_Price_Unit
      };

      const serviceRequest = Id
        ? JobOtherPricesService.editJobOtherPrices(Id, modifiedItem)
        : JobOtherPricesService.createJobOtherPrices({
            Array: [modifiedItem]
          });

      addEditServiceRequest({
        showAlert,
        setLoading,
        serviceRequest,
        navigated: (navi) =>
          navi && refreshAt === "JobOther" && commonNavigate(Inform_Id)
      });
    });
  };

  const handleUploadFile = ({ destination, files, Inform_Id, refreshAt }) => {
    addEditServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: FileUploadsService.createFileUploads(destination, files),
      callback: (response) => {
        const InformFile = {
          Array: response.files.map((item) => ({
            File_Path: `${destination}/${item}`,
            File_Type: ["jpg", "jpeg", "png"].includes(item.split(".").pop())
              ? "Image"
              : "Video",
            Inform_Other_Job_Id: Inform_Id
          }))
        };
        handleSubmitInformFiles({ InformFile, Inform_Id, refreshAt });
      }
    });
  };

  const handleSubmitInformFiles = ({ InformFile, Inform_Id, refreshAt }) => {
    addEditServiceRequest({
      showAlert,
      setLoading,
      serviceRequest:
        InformOtherJobFilesService.createInformOtherJobFiles(InformFile),
      navigated: (navi) =>
        navi && refreshAt === "InformFiles" && commonNavigate(Inform_Id)
    });
  };

  return <CreateJobForm editData={editData} onSubmitCallback={handleSubmit} />;
}
